import { Card, Flag, withStyles, VirtualAccount } from 'vopay';
import styles from './BalanceDetailsHeader.module.scss';
import { useTranslation } from 'react-i18next';
import { Balance } from '@/hooks/useApi/useAccountBalances';
import { Button, CopyButton, Title } from 'UI';
import { useClientData } from '@/providers/ClientData.provider';

const cn = withStyles(styles);

type BalanceDetailsHeaderProps = {
  balance: Balance;
  virtualAccount: VirtualAccount | null;
  onSimulateInboundTransfer: (virtualAccountID: string, currency: string) => Promise<void>;
};

export default function BalanceDetailsHeader({
  balance,
  virtualAccount,
  onSimulateInboundTransfer,
}: BalanceDetailsHeaderProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'BalanceDetailsHeader' });
  const simulateInboundTransferEnabled = import.meta.env.VITE_SIMULATE_INBOUND_TRANSFERS_ENABLED === 'true';

  const {
    response: { VirtualAccountsEnabled },
  } = useClientData();

  const account = virtualAccount
    ? [
        virtualAccount.IBAN,
        virtualAccount.BicSwift,
        virtualAccount.FinancialInstitutionNumber,
        virtualAccount.BranchTransitNumber,
        virtualAccount.ABARoutingNumber,
        virtualAccount.AccountNumber,
      ]
        .filter((value) => Boolean(value))
        .join('-')
    : '';

  return (
    <Card className={cn('detailsHeader')}>
      <Flag flag={balance.Currency} width="32px" />

      <div>
        <Title level="4">{balance.Currency}</Title>

        {virtualAccount && (
          <div className={cn('accountInfo')}>
            <span>{account}</span>
            <CopyButton content={account} size={'16px'} />
          </div>
        )}
      </div>

      {VirtualAccountsEnabled &&
        simulateInboundTransferEnabled &&
        virtualAccount &&
        virtualAccount.Status === 'Active' && (
          <Button
            className={cn('simulateInboundButton')}
            onClick={() => {
              onSimulateInboundTransfer(virtualAccount.VirtualAccountID, balance.Currency);
            }}
            iconLeft="arrow_downward"
            size="small"
          >
            {t('simulateInbound', { defaultValue: 'Simulate Inbound' })}
          </Button>
        )}
    </Card>
  );
}
